var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconRefresh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "refresh")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.0\\u6539\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bridge_bitcoin1",
    transform: "translate(-936.000000, -586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(687.000000, 134.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(24.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(223.000000, 376.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,6.5 L2.5,6.5 C2.22385763,6.5 2,6.27614237 2,6 L2,3 C2,2.72385763 2.22385763,2.5 2.5,2.5 C2.77614237,2.5 3,2.72385763 3,3 L3,4.490625 C3.966875,3.4 5.663125,2 8,2 C10.67625,2 12.28625,3.579375 12.35375,3.64625 C12.5494659,3.84127555 12.5500255,4.15803408 12.355,4.35374999 C12.1599744,4.54946589 11.8432159,4.55002554 11.6475,4.355 C11.630625,4.338125 10.245,3 8,3 C5.8125,3 4.235625,4.540625 3.465,5.5 L5.5,5.5 C5.77614237,5.5 6,5.72385763 6,6 C6,6.27614237 5.77614237,6.5 5.5,6.5 Z M13.5,9.5 L10.5,9.5 C10.2238576,9.5 10,9.72385763 10,10 C10,10.2761424 10.2238576,10.5 10.5,10.5 L12.535,10.5 C11.764375,11.459375 10.1875,13 8,13 C5.755,13 4.369375,11.661875 4.3525,11.645 C4.15678409,11.4499745 3.84002556,11.4505341 3.64500001,11.64625 C3.44997446,11.8419659 3.4505341,12.1587244 3.64625,12.35375 C3.71375,12.420625 5.32375,14 8,14 C10.336875,14 12.033125,12.6 13,11.509375 L13,13 C13,13.2761424 13.2238576,13.5 13.5,13.5 C13.7761424,13.5 14,13.2761424 14,13 L14,10 C14,9.72385763 13.7761424,9.5 13.5,9.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#48E8CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_refresh.25f75a72.svg";
export { ForwardRef as ReactComponent };